export default __webpack_public_path__ + "static/section-1-img-1@2x-b47042d805dbe3ec54da2c8df44b1971.png";